<p *ngIf="accessDenied">
    Zugang verweigert <a class="btn btn-secondary btn-sm" routerLink="/light">Zurück</a>
</p>

<p *ngIf="missing">
    Nicht gefunden <a class="btn btn-secondary btn-sm" routerLink="/light">Zurück</a>
</p>

<ng-container *ngIf="!accessDenied && !missing">
    <div class="card my-3">
        <div class="card-header">
            <div style="display: grid; grid-template-columns: auto auto">
                <h3>
                    <span *ngIf="project"><span *ngIf="project?.number">PRL{{ project?.number | number: '3.0'}}</span> "{{ project?.title }}"</span>
                    <span *ngIf="!project">Neues Projekt</span>
                </h3>

                <div class="text-end">
                    <button type="button" class="btn btn-secondary" (click)="gotoList()">Zurück</button>

                    <button type="button" class="btn btn-danger ms-2"
                            (click)="delete()"
                            *ngIf="PID !== '0'">Löschen
                    </button>
                </div>
            </div>

            <div class="container-fluid">
                <div class="row row-status mb-2">
                    <ng-container *ngIf="project?.status === LightStatus.OPEN">
                        <div class="col current"><i class="fa-solid fa-check"></i> Offen</div>
                        <div class="col">In Arbeit</div>
                        <div class="col">Erledigt</div>
                    </ng-container>
                    <ng-container *ngIf="project?.status === LightStatus.IN_PROGRESS">
                        <div class="col done"><i class="fa-solid fa-check"></i> Offen</div>
                        <div class="col current"><i class="fa-solid fa-check"></i> In Arbeit</div>
                        <div class="col">Erledigt</div>
                    </ng-container>
                    <ng-container *ngIf="project?.status === LightStatus.COMPLETED">
                        <div class="col-2 done"><i class="fa-solid fa-check"></i> Offen</div>
                        <div class="col-2 done"><i class="fa-solid fa-check"></i> In Arbeit</div>
                        <div class="col-2 current"><i class="fa-solid fa-check"></i> Erledigt</div>
                    </ng-container>
                    <ng-container *ngIf="project?.status === LightStatus.ON_HOLD">
                        <div class="col done"><i class="fa-solid fa-check"></i> On Hold</div>
                        <div class="col">Offen</div>
                        <div class="col">In Arbeit</div>
                        <div class="col">Erledigt</div>
                    </ng-container>
                </div>
            </div>

            <ul class="nav nav-tabs card-header-tabs">
                <li class="nav-item">
                    <a class="nav-link" data-toggle="tab"
                       [class.active]="tab === LightTab.GENERAL"
                       (click)="setTab(LightTab.GENERAL)">
                        Allgemeines
                    </a>
                </li>
                <li class="nav-item" *ngIf="PID !== '0'">
                    <a class="nav-link" data-toggle="tab"
                       [class.active]="tab === LightTab.REPORTING       "
                       (click)="setTab(LightTab.REPORTING)">
                        Statusupdate
                    </a>
                </li>
            </ul>
        </div>

        <ng-container *ngIf="tab === LightTab.GENERAL">
            <form [formGroup]="form">
                <div class="card-header bg-white">
                    <button type="button" class="btn btn-primary"
                            *ngIf="viewMode === ViewMode.VIEW"
                            (click)="setMode(ViewMode.EDIT)">Bearbeiten
                    </button>

                    <ng-container *ngIf="viewMode === ViewMode.EDIT">
                        <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="update()">Speichern</button>
                        <button type="button" class="btn btn-secondary ms-2" (click)="cancelEdit()">Abbrechen</button>
                    </ng-container>

                    <ng-container *ngIf="viewMode === ViewMode.INSERT">
                        <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="save()">Speichern</button>
                        <button type="button" class="btn btn-secondary ms-2" (click)="cancelCreate()">Abbrechen</button>
                    </ng-container>
                </div>
                <div class="card-body">

                    <div class="row" *ngIf="PID !== '0'">
                        <div class="col">
                            <div class="mb-2">
                                <label>Eingereicht von</label>
                                <p>{{ project?.creator }}</p>
                            </div>
                        </div>
                        <div class="col">
                            <div class="mb-2">
                                <label>Eingereicht am</label>
                                <p>{{ project?.date_created | date: 'dd.MM.yyyy' }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col" *ngIf="project">
                            <div class="mb-2">
                                <label>Projektnummer</label>
                                <p>PRL{{ project?.number | number: '3.0'}}</p>
                            </div>
                        </div>
                        <div class="col">
                            <div class="mb-2">
                                <label>Titel</label>
                                <ng-container *ngIf="viewMode !== ViewMode.VIEW">
                                    <input type="text" class="form-control" formControlName="title" [maxlength]="80">
                                    <div class="mb-1 small">{{ form.value.title ? form.value.title.length : 0 }}/80</div>
                                </ng-container>
                                <p *ngIf="viewMode === ViewMode.VIEW">{{ form.value.title }}</p>
                            </div>
                        </div>
                        <div class="col">
                            <div class="mb-2">
                                <label>Projektleiter</label>
                                <ng-container *ngIf="viewMode !== ViewMode.VIEW">
                                    <input class="form-control" typeaheadOptionField="displayName"
                                           formControlName="_userSearch"
                                           [typeahead]="users$"
                                           [typeaheadAsync]="true"
                                           [typeaheadMinLength]="4"
                                           [typeaheadWaitMs]="1000"
                                           (typeaheadOnSelect)="onSelectUser($event)"
                                           (typeaheadNoResults)="typeaheadUsersNoResults($event)"
                                           (typeaheadLoading)="typeaheadUsersLoading($event)"
                                           autocomplete="off"
                                           placeholder="Bitte Benutzer suchen">

                                    <span *ngIf="loading"><i class="fa fa-spinner fa-pulse fa-2x mt-2"></i></span>

                                    <p *ngIf="noUserResult" class="bg-warning px-2 py-1 mt-2">Keine Benutzer gefunden</p>
                                </ng-container>
                                <p *ngIf="viewMode === ViewMode.VIEW">
                                    {{ form.value.lead }}
                                    <span class="text-muted" *ngIf="!form.value.lead">Nicht eingetragen</span>
                                </p>
                            </div>
                        </div>
                        <div class="col">
                            <div class="mb-2">
                                <label>Status</label>
                                <select class="form-control" formControlName="status" *ngIf="viewMode !== ViewMode.VIEW">
                                    <option *ngFor="let status of lightStatusList" [value]="status">
                                        {{ status }}
                                    </option>
                                </select>
                                <p *ngIf="viewMode === ViewMode.VIEW">
                                    {{ form.value.status }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="mb-2">
                        <label>Strategische Zuordnung</label>
                        <select class="form-control" formControlName="strategic_classification_root"
                                *ngIf="viewMode !== ViewMode.VIEW">
                            <option value="" disabled selected style="display: none;">Wählen Sie jene Strategie-Säule aus, auf die das Projekt aus Ihrer Sicht den größten Einfluss hat</option>
                            <option *ngFor="let classification of strategicClassifications" [ngValue]="classification">
                                {{ classification.name }}
                            </option>
                        </select>
                        <select class="form-control" formControlName="strategic_classification"
                                *ngIf="viewMode !== ViewMode.VIEW && form.value.strategic_classification_root">
                            <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                            <option *ngFor="let sub of form.value.strategic_classification_root.subs" [ngValue]="sub">
                                {{ sub }}
                            </option>
                        </select>
                        <p *ngIf="viewMode === ViewMode.VIEW">
                            <ng-container *ngIf="form.value.strategic_classification">{{ form.value.strategic_classification_root?.name }} / {{ form.value.strategic_classification }}</ng-container>
                            <span class="text-danger" *ngIf="!form.value.strategic_classification">Nicht eingetragen</span>
                        </p>
                    </div>

                    <div class="row">
                        <div class="col">
                            <div class="mb-2">
                                <label>Länderbereich</label>
                                <select class="form-control" formControlName="id_region" *ngIf="viewMode !== ViewMode.VIEW">
                                    <option value="" disabled selected style="display: none;">Länderbereich auswählen</option>
                                    <option *ngFor="let region of regions" [ngValue]="region.id">
                                        Region {{ region.region }} ({{ region.countries }})
                                    </option>
                                </select>
                                <p *ngIf="viewMode === ViewMode.VIEW">
                                    {{ form.value.region }}
                                    <span class="text-muted" *ngIf="!form.value.region">Nicht eingetragen</span>
                                </p>
                            </div>
                        </div>
                        <div class="col">
                            <div class="mb-2">
                                <label>Abteilung</label>
                                <select class="form-control" formControlName="id_department" *ngIf="viewMode !== ViewMode.VIEW">
                                    <option value="" disabled selected style="display: none;">Abteilung auswählen</option>
                                    <option *ngFor="let department of departments" [ngValue]="department.id">
                                        {{ department.name }} ({{ department.lead }})
                                    </option>
                                </select>
                                <p *ngIf="viewMode === ViewMode.VIEW">
                                    {{ form.value.department }}
                                    <span class="text-muted" *ngIf="!form.value.department">Nicht eingetragen</span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-6">
                            <div class="mb-2">
                                <label>Länder</label>
                                <select class="form-control" formControlName="countries" *ngIf="viewMode !== ViewMode.VIEW" multiple>
                                    <option value="" disabled selected style="display: none;">Länder in dem das Projekt durchgeführt wird</option>
                                    <option *ngFor="let country of countries" [ngValue]="country">
                                        {{ country.name }}
                                    </option>
                                </select>
                                <p *ngIf="viewMode === ViewMode.VIEW">
                                    {{ form.value.countryNames }}
                                    <span class="text-muted" *ngIf="!form.value.countryNames">Nicht eingetragen</span>
                                </p>
                            </div>
                        </div>
                        <div class="col-6" *ngIf="displayLocation()">
                            <div class="mb-2">
                                <label>Standort</label>
                                <select class="form-control" formControlName="id_location" *ngIf="viewMode !== ViewMode.VIEW">
                                    <option value="">Keine Auswahl</option>
                                    <option *ngFor="let location of locations" [ngValue]="location.id">
                                        {{ location.name }}
                                    </option>
                                </select>
                                <p *ngIf="viewMode === ViewMode.VIEW">
                                    {{ form.value.location }}
                                    <span class="text-muted" *ngIf="!form.value.location">Nicht eingetragen</span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="mb-2">
                        <label>Nutzenbeschreibung</label>
                        <ng-container *ngIf="viewMode !== ViewMode.VIEW">
                            <textarea class="form-control" formControlName="benefit" rows="4" [maxlength]="1000"
                                      placeholder="Beschreiben Sie kurz welche Verbesserungen (der Ausgangslage) Sie sich nach einer erfolgreichen Projektumsetzung erwarten">
                            </textarea>
                            <div class="mb-1 small">{{ form.value.benefit ? form.value.benefit.length : 0 }}/1000</div>
                        </ng-container>
                        <p *ngIf="viewMode === ViewMode.VIEW">
                            {{ form.value.benefit }}
                            <span class="text-muted" *ngIf="!form.value.benefit">Nicht eingetragen</span>
                        </p>
                    </div>

                    <div class="row">
                        <div class="col">
                            <div class="mb-2">
                                <label>Budget</label>
                                <ng-container *ngIf="viewMode !== ViewMode.VIEW">
                                    <input type="number" class="form-control" formControlName="budget">
                                </ng-container>
                                <p *ngIf="viewMode === ViewMode.VIEW">
                                    {{ form.value.budget | number }}
                                    <span class="text-muted" *ngIf="!form.value.budget">Nicht eingetragen</span>
                                </p>
                            </div>
                        </div>
                        <div class="col">
                            <div class="mb-2">
                                <label>Projektstart</label>
                                <ng-container *ngIf="viewMode !== ViewMode.VIEW">
                                    <input type="date" class="form-control" formControlName="start">
                                </ng-container>
                                <p *ngIf="viewMode === ViewMode.VIEW">{{ form.value.start | date: 'dd.MM.yyyy' }}</p>
                            </div>
                        </div>
                        <div class="col">
                            <div class="mb-2">
                                <label>Projektende</label>
                                <ng-container *ngIf="viewMode !== ViewMode.VIEW">
                                    <input type="date" class="form-control" formControlName="end">
                                </ng-container>
                                <p *ngIf="viewMode === ViewMode.VIEW">
                                    {{ form.value.end | date: 'dd.MM.yyyy' }}
                                    <span class="text-muted" *ngIf="!form.value.end">Nicht eingetragen</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

        </ng-container>

            <ng-container *ngIf="tab === LightTab.REPORTING">
                <div class="card-body">

                    <h4>Statusberichte ({{ statusReports.length}})</h4>

                    <button type="button" class="btn btn-primary" (click)="addStatusReport()" [disabled]="newStatusReport">Statusbericht hinzufügen</button>

                    <p class="text-muted mt-2" *ngIf="statusReports.length === 0">Keine Statusberichte angelegt</p>

                    <table class="table table-striped table-sm mb-0">
                        <thead>
                        <tr>
                            <th style="width: 100px"></th>
                            <th>#</th>
                            <th style="width: 120px">Datum</th>
                            <th>Status</th>
                            <th>Kommentar</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngIf="newStatusReport">
                            <td>
                                <button type="button" class="btn btn-success btn-sm" (click)="saveStatusReport()">
                                    <i class="fas fa-check"></i>
                                </button>
                                <button type="button" class="btn btn-secondary btn-sm ms-1" (click)="cancelAddStatusReport()">
                                    <i class="fas fa-times-fw"></i>
                                </button>
                            </td>
                            <td>
                                {{ statusReports.length + 1 }}
                            </td>
                            <td>
                                {{ newStatusReport.created_at | date: 'dd.MM.yyyy HH:mm'}}
                            </td>
                            <td>
                                <button type="button" class="btn btn-secondary btn-sm me-2"
                                        [class.btn-success]="newStatusReport.color === 'Grün'"
                                        (click)="setReportStatus(newStatusReport, 'Grün')">im Plan
                                </button>
                                <button type="button" class="btn btn-secondary btn-sm me-2"
                                        [class.btn-warning]="newStatusReport.color === 'Gelb'"
                                        (click)="setReportStatus(newStatusReport, 'Gelb')">leichte Veränderung
                                </button>
                                <button type="button" class="btn btn-secondary btn-sm"
                                        [class.btn-danger]="newStatusReport.color === 'Rot'"
                                        (click)="setReportStatus(newStatusReport, 'Rot')">Handlungsbedarf
                                </button>
                            </td>
                            <td>
                                <div class="mb-2">
                                    <textarea class="form-control" [(ngModel)]="newStatusReport.comment" rows="4">
                                            </textarea>
                                </div>
                            </td>
                        </tr>
                        <tr *ngFor="let entry of statusReports; let i = index">
                            <td>
                                @if (entry.editing) {
                                    <button type="button" class="btn btn-success btn-sm"
                                        (click)="updateStatusReport(entry)"><i class="fas fa-check"></i></button>
                                    <button type="button" class="btn btn-secondary btn-sm ms-1"
                                        (click)="cancelEditStatusReport(entry)"><i class="fas fa-times"></i></button>
                                }
                                @if (!entry.editing) {
                                    <button type="button" class="btn btn-primary btn-sm"
                                            (click)="editStatusReport(entry)">
                                        <i class="fas fa-pencil"></i>
                                    </button>
                                    <button type="button" class="btn btn-danger btn-sm ms-1"
                                            (click)="deleteStatusReport(entry)">
                                        <i class="fas fa-trash"></i>
                                    </button>
                                }
                            </td>
                            <td>
                                {{ statusReports.length - i }}
                            </td>
                            <td>
                                {{ entry.created_at | date: 'dd.MM.yyyy HH:mm'}}
                            </td>
                            <td>
                                @if (entry.editing) {
                                    <div class="btn-group w-100" role="group">
                                        <button type="button" class="btn btn-secondary btn-sm"
                                                [class.btn-success]="entry.color === 'Grün'"
                                                (click)="setReportStatus(entry, 'Grün')">im Plan
                                        </button>
                                        <button type="button" class="btn btn-secondary btn-sm"
                                                [class.btn-warning]="entry.color === 'Gelb'"
                                                (click)="setReportStatus(entry, 'Gelb')">leichte Veränderung
                                        </button>
                                        <button type="button" class="btn btn-secondary btn-sm"
                                                [class.btn-danger]="entry.color === 'Rot'"
                                                (click)="setReportStatus(entry, 'Rot')">Handlungsbedarf
                                        </button>
                                    </div>
                                }
                                @if (!entry.editing) {
                                    <span class="badge"
                                          [class.bg-success]="entry.color === 'Grün'"
                                          [class.bg-warning]="entry.color === 'Gelb'"
                                          [class.bg-danger]="entry.color === 'Rot'"
                                    >
                                        <span *ngIf="entry.color === 'Grün'">im Plan</span>
                                        <span *ngIf="entry.color === 'Gelb'">leichte Veränderung</span>
                                        <span *ngIf="entry.color === 'Rot'">Handlungsbedarf</span>
                                    </span>
                                }
                            </td>
                            <td>
                                @if (entry.editing) {
                                    <textarea class="form-control" [(ngModel)]="entry.comment" rows="4"></textarea>
                                }
                                @if (!entry.editing) {
                                    {{ entry.comment }}
                                }
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </ng-container>


    </div>
</ng-container>
